<template>
  <div class="slider__card">
    <img src="~@/assets/images/slider-item-imgs/ico223.svg" alt="ico223.svg">
    <div class="text-container">
      <text-string label-id="txt1434"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "storage-instruction-two",
  }
</script>
